<template>
  <v-footer dark
            height="auto"
            style="padding: 0;">
    <v-card class="flex"
            flat
            tile>
      <v-card-title class="green darken-3">
        <strong class="subheading"
                style="text-indent: 2em;">学习，已经成为在这个时代生存的一项基本技能,勇敢接受新鲜事物，并用它来帮助自己快速发展 !</strong>

        <v-spacer></v-spacer>

        <v-btn v-for="icon in icons"
               :key="icon"
               class="mx-3"
               dark
               icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-actions class="grey darken-3 justify-center">
        &copy;2018&nbsp;—&nbsp;
        <strong>职业技能鉴定中心</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-linkedin',
      'fab fa-instagram'
    ]
  })
}
</script>